import { render, staticRenderFns } from "./HRMAddNewTaskModal.vue?vue&type=template&id=9ca9051a&"
import script from "./HRMAddNewTaskModal.vue?vue&type=script&lang=js&"
export * from "./HRMAddNewTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports